import { cx } from '@platform/core/lib/cx';
import type { IFilterChipProps } from './IFilterChipProps';

/**
 * Чип активного фільтра в рядку фільтрів (прототип v4): пункт меню — 28px з рамкою акценту, швидкий фільтр і умови розширених фільтрів —
 * 26px на --accent-soft; × скидає саме цей фільтр. Довгий підпис обрізається з «…», повний — у підказці.
 */
export function FilterChip({ label, onClear, clearLabel, outlined = false }: IFilterChipProps) {
  return (
    <span className={cx('lv-chip', !outlined && 'lv-chip--soft')}>
      <span className="lv-chip__text" title={label}>{label}</span>
      <button type="button" className="lv-chip__x" aria-label={`${clearLabel}: ${label}`} title={clearLabel} onClick={onClear}>×</button>
    </span>
  );
}
